import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d5bcff16&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=d5bcff16&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5bcff16",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chillzon/Documents/projects/crmeb_view/mer_plat_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d5bcff16')) {
      api.createRecord('d5bcff16', component.options)
    } else {
      api.reload('d5bcff16', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=d5bcff16&scoped=true", function () {
      api.rerender('d5bcff16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/systemSetting/agreement/index.vue"
export default component.exports